<template>
  <div class="center size">
    <VBidderTemplateParamterItem
      :item="row"
      :is-disabled="headCell.decorator.isDisabled"
      class-item="mb-0 mh-0 border-all" />
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue'
import { decoratorProps } from '@/mixin/props'
import VBidderTemplateParamterItem from '@/components/views/Lot/Parameter/Part/VBidderTemplateParamterItem'

defineEmits([...decoratorProps.emits])
defineProps({
  ...decoratorProps.props,
})
</script>

<style scoped>
.size {
  width: 300px;
  padding: 20px 0;
}

.mh-0 {
  min-height: auto;
}
</style>
